<template>
  <div class="nav_tools_wrap">
    <div class="content">
      <div class="sec_nav_container" v-show="displaySecNav">
        <SecNavBar></SecNavBar>
      </div>
      <div class="breadcrumb_container" v-show="displayBreadcrumb">
        <Breadcrumb></Breadcrumb>
      </div>
    </div>
  </div>
</template>

<script>
  import SecNavBar from '@/components/nav-bar/SecNavBar.vue';
  import Breadcrumb from '@/components/Breadcrumb.vue';
  export default {
    components: { SecNavBar, Breadcrumb },
    props: {
      displaySecNav: {
        type: Boolean,
        default: true
      },
      displayBreadcrumb: {
        type: Boolean,
        default: true
      }
    }
  }
</script>

<style scoped lang="scss">
.nav_tools_wrap {
  width: 100%;
  height: auto;
  min-height: 60px;
  border-bottom: 1px solid #f7f7f7;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 0 2px 2px #ddd;
}
.content {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  width: 94%;
  max-width: 1280px;
  margin: 0 auto;
}
</style>
